<!--
Author: TangChen
Date: 2018-10-08
Desc: 手机号码绑定，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-check-mobile bizcomp ' + className">
        <comp-title :title="title" />
        <nav-tips :data="titTips" />
        <div class="acct-con">
            <div class="check-acct">
                <el-form
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="240px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item label="原手机号码：" class="form-text">
                        <div class="text-con">
                            {{ info.mobile }}
                        </div>
                    </el-form-item>
                    <el-form-item label="手机验证码：" prop="verifyCode" class="verifycode-row">
                        <!-- <el-input
                            v-model.trim="pwdForm.verifyCode"
                            placeholder="请输入手机验证码"
                            :maxlength="6"
                        >
                            <el-button
                                slot="append"
                                class="get-verify"
                                :disabled="time>0"
                                v-on:click="sendCode"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </el-input> -->
                        <el-row>
                            <el-col :span="8">
                                <el-input
                                    v-model.trim="pwdForm.verifyCode"
                                    class="verifycode-style"
                                    placeholder="请输入手机验证码"
                                    :maxlength="6"
                                >
                                </el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button
                                    class="get-verify"
                                    :disabled="time>0"
                                    v-on:click="sendCode"
                                >
                                    {{ btnMsg }}
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <div style="width:50%;">
                            <el-button type="primary" class="medium" v-on:click="submitForm('pwdForm')">
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="back">
                                返回
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navTips from "@/components/form/navTips.vue";
import imgCode from "@/components/layout/imgCode.vue";
export default {
    name: "CheckAcct",
    components: {
        navTips,
        imgCode
    },
    mixins: [mixin],
    data () {
        return {
            time: 0, // 验证码再次发送间隔
            pwdForm: { // 表单参数配置
                mobile: "",
                verifyCode: ""
            },
            titTips: {
                tit: "您还未绑定手机号",
                text: "绑定后可通过手机号快速登录"
            },
            pwdSet: {
                btn1: "确认",
                text: "登录"
            },
            info: {},
            dialogVisible: false,
            btnMsg: "获取验证码",
            plaC: "请输入手机号码",
            locked: false, // 是否已发送短信验证码
            resetPwd: false,
            result: false,
            rules: { // 校验规则
                verifyCode: [
                    { validator: this.$util.validateVerifyCode, trigger: "blur" }
                ]
            }
        };
    },
    created () {
        this.info = this.$cache.getUser();
        this.titTips = {
            tit: "您的账号已绑定手机号" + this.info.mobile,
            text: "您可以修改绑定其它手机号"
        };
    },
    methods: {
        /* 提交表单数据,校验手机验证码 */
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送手机短信验证码"
                        });
                        return false;
                    }
                    this.checkVerifyCode();
                } else {
                    // todo
                    return false;
                }
            });
        },
        // 获取验证码
        sendCode(){
            if(this.time > 0)return;
            this.dialogVisible = true;
        },
        // 校验手机号
        mobile (rule, value, callback) {
            if (value === this.info.mobile) {
                callback();
            } else {
                this.$util.validateMobile(rule, value, callback);
            }
        },
        /* 提交表单数据 */
        mobileCheck () {
            let _this = this;
            this.$refs.pwdForm.validateField("mobile", function (str) {
                if (str === "") {
                    _this.getVerifyCode();
                } else {
                    return false;
                }
            });
        },
        /* 校验手机验证码 */
        checkVerifyCode () {
            let url = "acct/sms/check";
            let _this = this;
            this.$util.request(url, {
                verifycode: this.pwdForm.verifyCode,
                biztype: "checkoldmob"
            }, "POST").then(res => {
                if (res.data) {
                    _this.$router.push({name: "changemobile"});
                }
            });
        },
        /* 获取图形验证码值 */
        getVerifyCode (val) {
            const _this = this;
            this.dialogVisible = false;
            if(val){
                this.$util.request("acct/common/sendsms", {verifycode: val,biztype: "checkoldmob"}, "POST").then(res => {
                    if (res.data) {
                        _this.time = res.data[0].sendperiod;
                        _this.locked = true;
                        _this.$util.btnDisabled(_this);
                    }
                });
            }
        },
        /* 回到登录页面 */
        backFrame () {
            this.$router.push("/home");
        },
        /* 返回登录页 */
        back () {
            this.$router.back();
        },
        /* 返回个人中心 */
        backcenter () {
            this.$router.push("/securitycenter");
        }
    }
};
</script>
<style lang="scss">
    @import "../../assets/css/varibles";
    .bizcomp-check-mobile {
        min-height: 400px;
        .acct-con {
            padding: 20px;
        }
        .check-acct {
            margin-top: 20px;
        }
        .pwdForm {
            .el-form-item {
                .el-select {
                    width: 50%;
                    .el-input {
                        width: 100%;
                    }
                }
                &.form-text {
                    margin-bottom: 10px;
                    .text-con {
                        color: $text-color3;
                    }
                }
                .el-form-item__label {
                    color: $text-color3;
                    &:before {
                        display: none;
                    }
                }
                .el-input {
                    width: 50%;
                    &.verifycode-style {
                        width: 98%;
                    }
                    .get-verify {
                        color: $color-a;
                        min-width: 140px;
                    }
                    .el-button.is-disabled {
                        color: $text-color3;
                    }
                    .fa {
                        margin-right: 6px;
                    }
                }
                .get-verify {
                    color: $color-b-o;
                    min-width: 100px;
                    width: 100%;
                }
                .el-button.is-disabled {
                    color: $text-color3;
                    background-color: transparent;
                }
                &.verifycode-row {
                    >.el-form-item__content>.el-form-item__error {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
                .el-button + .el-button {
                    float: right;
                }
                .el-form-item__error--inline {
                    color: $color-c;
                }
            }
        }
    }
</style>
